import { render } from "./Header.vue?vue&type=template&id=0954d1dc&scoped=true"
import script from "./Header.vue?vue&type=script&lang=ts"
export * from "./Header.vue?vue&type=script&lang=ts"

import "./Header.vue?vue&type=style&index=0&id=0954d1dc&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0954d1dc"

export default script